import React, { useState, useEffect } from 'react';
import { Alert, AlertTitle } from '@material-ui/lab';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';
import { DialogContent, DialogContentText } from '@material-ui/core';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { actions as userActions } from 'store/user';
import { TIMEOUT_MODAL_WARNING_SECONDS } from 'constants.js';

const useStyles = makeStyles(theme => ({
  timer: {
    marginBottom: theme.spacing(2)
  },
  instructionText: {
    marginBottom: '0px'
  }
}));

export default props => {
  const classes = useStyles();
  const { setShowDefaultButtons, handleClose } = props;
  let warningTime = window._env_.ADM_SESSION_TIMEOUT_WARNING_MINS ? window._env_.ADM_SESSION_TIMEOUT_WARNING_MINS*60 : TIMEOUT_MODAL_WARNING_SECONDS;
  const [timeLeft, setTimeLeft] = useState(warningTime);
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    let timer = setInterval(() => {
      if (timeLeft === 1) {
        clearInterval(timer);
        setShowDefaultButtons(false);
        dispatch(userActions.logout({ preventRedirect: true }));
        // Auto redirect to sign-in after logout
        setTimeout(() => {
          window.location.href = window.location.origin + (window._env_?.REACT_APP_BASENAME || '/gcm/') + 'sign-in';
        }, 500);
      }
      setTimeLeft(timeLeft - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [setTimeLeft, timeLeft]);

  const onGotToSignIn = () => {
    handleClose();
    // Use full page reload to ensure clean state after logout
    window.location.href = window.location.origin + (window._env_?.REACT_APP_BASENAME || '/gcm/') + 'sign-in';
  };

  const ContentBeforeExpire = props => {
    return (
      <>
        <Alert severity="warning">
          <AlertTitle>Session Time Out</AlertTitle>
        </Alert>
        <DialogContent>
          <DialogContentText align="center" id="alert-dialog-description">
            Your session will expire in
          </DialogContentText>
          <DialogContentText
            align="center"
            variant="h2"
            className={classes.timer}>
            {props.timeLeft} seconds
          </DialogContentText>
          <DialogContentText className={classes.instructionText} align="center">
            If you wish to continue please do.
          </DialogContentText>
          <DialogContentText className={classes.instructionText} align="center">
            Otherwise you will be logged out for security purposes
          </DialogContentText>
        </DialogContent>
      </>
    );
  };

  const ContentAfterExpire = props => {
    return (
      <>
        <Alert severity="warning">
          <AlertTitle>Session Has Timed Out</AlertTitle>
        </Alert>
        <DialogContent>
          <DialogContentText align="center" id="alert-dialog-description">
            Your session has expired
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <DialogActions>
            <Button onClick={onGotToSignIn}>Go to Sign In</Button>
          </DialogActions>
        </DialogActions>
      </>
    );
  };

  return (
    <>
      {timeLeft > 0 && <ContentBeforeExpire timeLeft={timeLeft} />}
      {timeLeft <= 0 && <ContentAfterExpire />}
    </>
  );
};
